(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    (function () {
  function syncLineItemPropertiesForForm(form) {
    console.log("syncLineItemPropertiesForForm");
    if (!form || !form.hasAttribute('data-product-form')) return;
    var noukiInput = form.querySelector('[name="properties[custom-nouki]"]');
    var markInput = form.querySelector('[name="properties[custom-mark]"]');
    if (!noukiInput || !markInput) return;
    var nouki = '';
    var mark = '';
    var selects = form.querySelectorAll('.variants-ui__input-select');
    if (selects.length) {
      const option_values = [];
      selects.forEach(function (sel) {
        var opt = Array.prototype.find.call(sel.options, function (o) {
          return o.value === sel.value && !o.disabled;
        });
        if (opt) {
          option_values.push(opt.value);
          if (opt.dataset.variantOptionCustomNouki) nouki = opt.dataset.variantOptionCustomNouki;
          if (opt.dataset.variantOptionCustomMark) mark = opt.dataset.variantOptionCustomMark;
        }
      });
      var variantKey = option_values.join(' / ');
      var noukiMark = productVariantNoukiMarks[variantKey];
      if (noukiMark) {
        nouki = noukiMark[0] || '';
        mark = noukiMark[1] || '';
      }
    } else {
      var radios = form.querySelectorAll(
        '.variants-ui__option-values input[type="radio"][data-variant-option-value]:checked'
      );
      if (!radios.length) {
        return;
      }
      radios.forEach(function (input) {
        if (input.dataset.variantOptionCustomNouki) nouki = input.dataset.variantOptionCustomNouki;
        if (input.dataset.variantOptionCustomMark) mark = input.dataset.variantOptionCustomMark;
      });
    }
    console.log("noukiInput,markInput",nouki,mark);
    noukiInput.value = nouki || '';
    markInput.value = mark || '';
    noukiInput.dispatchEvent(new Event('change', { bubbles: true }));
    markInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function onChange(e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (
      t.matches('.variants-ui__input-select') ||
      t.matches('.variants-ui__option-values input[type="radio"][data-variant-option-value]')
    ) {
      var form = t.closest('[data-product-form]');
      if (form) syncLineItemPropertiesForForm(form);
    }
  }

  document.addEventListener('change', onChange);
  document.addEventListener('variant:changed', function () {
    document.querySelectorAll('[data-product-form]').forEach(syncLineItemPropertiesForForm);
  });
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.hasAttribute || !form.hasAttribute('data-product-form')) return;
      syncLineItemPropertiesForForm(form);
    },
    true
  );

  function runAll() {
    document.querySelectorAll('[data-product-form]').forEach(syncLineItemPropertiesForForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
